var BASE_PATH = '/czna-authorities';
/**
 * The section a record is shown in. CZNA-1577: the same decision as the edit route below,
 * for the detail and the „Zrušit s náhradou“ page too — a vocabulary term opened under
 * /authorities is a detail in a list it does not belong to.
 */
var sectionPathFor = function (record) {
    return (record.type.startsWith('VOCABULARY_') ? "".concat(BASE_PATH, "/vocabularies") : "".concat(BASE_PATH, "/authorities"));
};
/** The record's detail, in its own section. */
export var detailUrlFor = function (record) { return "".concat(sectionPathFor(record), "/").concat(record.id); };
/**
 * CZNA-1577 — the „Zrušit s náhradou“ page: `merge` for an ACTIVE record (TASK-109), `redirect`
 * for one in review (TASK-084). Both sections route both modes — the backend offers merge on a
 * vocabulary term too (RecordActionResolver), and the page must return to the term's section.
 */
export var replaceUrlFor = function (record, mode) {
    return "".concat(detailUrlFor(record), "/").concat(mode);
};
/**
 * Where the "Upravit" / "Editovat" action goes for a record.
 *
 * <p>Two reasons this is a function rather than a template literal at the call site.
 *
 * <p>First, the path was `/inventory/authorities/${id}/edit` until 2026-08-19 — a prefix this
 * app has never served (the module mounts under `/czna-authorities`, see routesConfig.ts), so
 * the button navigated to a blank route. It survived because nothing asserted on it: the
 * TASK-084 e2e spec used the same stale prefix, so the two agreed with each other and not
 * with the app.
 *
 * <p>Second, the destination genuinely depends on the record. Vocabulary terms and ordinary
 * authority records are edited by two different routes with two different form configs and
 * two different backend endpoints:
 *
 * <ul>
 *   <li>vocabulary term → `/vocabularies/:id/edit` (VocabularyEdit → PUT /vocabularies/{id},
 *       whose heading comes from the primary 901 translation);</li>
 *   <li>anything else → `/authorities/:id/edit` (RecordEdit → PUT /records/{id}, whose heading
 *       is composed by HeadingComposer).</li>
 * </ul>
 *
 * <p>Sending a vocabulary record to RecordEdit is not merely the wrong form: RecordEdit has no
 * form config for VOCABULARY_* types and renders its config-unavailable error, and
 * even past that, HeadingComposer has no recipe for VOCABULARY_* so it composes a blank heading
 * and the backend's TASK-131 guard rejects the save with 422 for ANY payload.
 *
 * <p><b>Why this lives in utils rather than next to a screen (DB-064).</b> It was defined inside
 * ReviewQueue, and every other screen hardcoded `/authorities/${id}/edit` instead. The review
 * queue was therefore the only place that got it right, and `RecordDetail` — the generic detail
 * pane that AuthoritiesList, VocabulariesList and Headings all render — sent every vocabulary
 * term to the unsupported-type banner. The backend GET and the `/vocabularies/:id/edit` screen
 * both worked; the button simply did not lead there. One definition, imported by everyone who
 * needs the decision, is the only shape in which the two cannot drift apart — and drift here is
 * invisible until someone clicks.
 *
 * <p>Note this is the only type-branch left in the queue. CZNA-580 removed the `isVocabulary`
 * gate that used to hide the redirect affordance in DeleteWithRefsDialog, since the review
 * endpoint no longer refuses a non-vocabulary record. Two different EDIT FORMS is a real
 * difference; a review action is not.
 */
export var editUrlFor = function (record) { return "".concat(detailUrlFor(record), "/edit"); };
